import React from 'react';
import styled from 'styled-components';
import { commonRoutes } from '../../routes';
import { useTranslate, translateArray } from '../../translate/I18n';
import BeelanceRoles from './BeelanceRoles';
import { assetize } from '../../utils/pureUtils';

import Box from '../atoms/Box';
import Button from '../atoms/Button';
import ButtonGradient from '../atoms/ButtonGradient';
import Img from '../atoms/Img';
import Text from '../atoms/Text';

import Link from '../atoms/Link';
import Testimonials from './Testimonials';
import FindFreelancersWithSkills from './FindFreelancersWithSkills';
import TrustedByBanner from '../elements/trustedByBanner/TrustedByBanner';

import { ROLES } from '../../constants';
import BackToTop from './BackToTop';
const { COMPANY } = ROLES;

const {
  general: { register }
} = commonRoutes;

const StyledWhiteButton = styled(Link)({
  background: '#fff',
  display: 'inline-block',
  border: '1px solid #D5D7D9',
  boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)',
  padding: '8px 16px',
  borderRadius: '8px',
  color: '#111517',
  fontWeight: '700',
  transition: 'background .3s ease',
  '&:hover': {
    background: '#F3F4F6'
  }
});

const section4ImageNames = ['sign-up', 'phone', 'mission', 'tab'];

const CompanyHomePage = () => {
  const { t } = useTranslate();

  return (
    <Box bg="#F3F4F6" pb="120px">
      <BackToTop />
      <Box
        textAlign="center"
        py="8%"
        background="linear-gradient(180deg, #FFFFFF 0%, #F3F4F6 100%)"
        overflow={{ _: 'hidden', xl: 'visible' }}
        position="relative">
        <Box maxWidth="1240px" mx="auto" px={{ _: 1, sm: 2, md: 3, lg: 4 }}>
          <Text tag="h1" styleName="wH1" mb={6} maxWidth="700px" mx="auto">
            {t('homePageCompany:header:title')}
          </Text>
          <Box maxWidth="700px" mx="auto">
            <FindFreelancersWithSkills />
          </Box>
        </Box>
        <Box position="absolute" left={{ _: '-112px', xl: '3%' }} top="20%" display={{ _: 'none', lg: 'block' }}>
          <Img
            alt="3D objects illustration"
            src={assetize('/homepage/bg-left-3.webp')}
            srcRetina={assetize('/homepage/bg-left-3@2x.webp')}
            fallback={assetize('/homepage/bg-left-3.png')}
            fallbackRetina={assetize('/homepage/bg-left-3@2x.png')}
            lazyloading={true}
          />
        </Box>

        <Box position="absolute" right={{ _: '-122px', xl: '1%' }} top="5%" display={{ _: 'none', lg: 'block' }}>
          <Img
            alt="3D objects illustration"
            src={assetize('/homepage/bg-right-3.webp')}
            srcRetina={assetize('/homepage/bg-right-3@2x.webp')}
            fallback={assetize('/homepage/bg-right-3.png')}
            fallbackRetina={assetize('/homepage/bg-right-3@2x.png')}
            lazyloading={true}
          />
        </Box>
      </Box>

      <Box maxWidth="1240px" mx="auto" px={{ _: 1, sm: 2, md: 3, lg: 4 }} mb={{ _: 8, lg: 20 }}>
        <Text tag="h2" styleName="wH2b" fontWeight="700" mb={3}>
          {t('homePageCompany:section1:title')}
        </Text>
        <Text color="#424547" fontSize="16px" lineHeight="20px" fontWeight="500" maxWidth="545px" mb="6">
          {t('homePageCompany:section1:description')}
        </Text>

        <BeelanceRoles />
      </Box>

      <Box maxWidth="1240px" mx="auto" px={{ _: 1, sm: 2, md: 3, lg: 4 }}>
      <Text fontSize="18px" lineHeight="26px" mb="2" fontWeight="600" textAlign="center">
          {t('homePageCompany:section2:title')}
        </Text>
      </Box>
      <TrustedByBanner />

      <Box maxWidth="1240px" mx="auto" px={{ _: 1, sm: 2, md: 3, lg: 4 }} mb={{ _: 8, lg: 20 }} mt={{ _: 8, lg: 20 }}>
        <Text tag="h2" styleName="wH2b" mb="3" textAlign="center">
          {t('homePageCompany:section3:title')}
        </Text>
        <Text color="#424547" fontSize="16px" lineHeight="20px" fontWeight="500" mb="5" textAlign="center">
          {t('homePageCompany:section3:description')}
        </Text>

        <Box
          background="#FFF"
          borderRadius="2"
          mb="3"
          p="4"
          display="flex"
          justifyContent="space-between"
          flexDirection={{ _: 'column', lg: 'row' }}>
          <Box>
            <Text fontSize="24px" lineHeight="28px" fontWeight="700" mb="2">
              {t('homePageCompany:section3:items:0:title')}
            </Text>

            <Text color="#424547" fontSize="16px" lineHeight="20px" fontWeight="500" maxWidth="420px">
              {t('homePageCompany:section3:items:0:description')}
            </Text>
          </Box>
          <Box pl={{ _: 0, lg: 5 }} mt={{ _: 3, lg: 0 }}>
            <Img
              alt={'3D scene with office objects and a pc and verified badge floating in the air'}
              src={assetize('/homepage/verified-experts.webp')}
              srcRetina={assetize('/homepage/verified-experts@2x.webp')}
              fallback={assetize('/homepage/verified-experts.png')}
              fallbackRetina={assetize('/homepage/verified-experts@2x.png')}
              lazyloading={true}
            />
          </Box>
        </Box>

        <Box display="flex" gap="24px" flexDirection={{ _: 'column', lg: 'row' }}>
          <Box background="#FFF" display="block" borderRadius="2" flex="1" p="4" pb="2">
            <Text fontSize="24px" lineHeight="28px" fontWeight="700" mb="2">
              {t('homePageCompany:section3:items:1:title')}
            </Text>
            <Text color="#424547" fontSize="16px" lineHeight="20px" fontWeight="500">
              {t('homePageCompany:section3:items:1:description')}
            </Text>
            <Box textAlign="center" mt="4">
              <Img
                alt={'a floating clock and message bubble'}
                src={assetize('/homepage/response-time.webp')}
                srcRetina={assetize('/homepage/response-time@2x.webp')}
                fallback={assetize('/homepage/response-time.png')}
                fallbackRetina={assetize('/homepage/response-time@2x.png')}
                lazyloading={true}
              />
            </Box>
          </Box>

          <Box background="#FFF" display="block" borderRadius="2" flex="1" p="4">
            <Text fontSize="24px" lineHeight="28px" fontWeight="700" mb="2">
              {t('homePageCompany:section3:items:2:title')}
            </Text>
            <Text color="#424547" fontSize="16px" lineHeight="20px" fontWeight="500">
              {t('homePageCompany:section3:items:2:description')}
            </Text>
            <Box textAlign="center" mt="4">
              <Img
                alt={'a medal'}
                src={assetize('/homepage/medal.webp')}
                srcRetina={assetize('/homepage/medal@2x.webp')}
                fallback={assetize('/homepage/medal.png')}
                fallbackRetina={assetize('/homepage/medal@2x.png')}
                lazyloading={true}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box maxWidth="1240px" mx="auto" px={{ _: 1, sm: 2, md: 3, lg: 4 }} mb={{ _: 8, lg: 20 }}>
        <Text tag="h2" styleName="wH2b" mb="6">
          {t('homePageCompany:section4:title')}
        </Text>
        <Box display="flex" gap="16px" flexDirection={{ _: 'column', lg: 'row' }}>
          {translateArray(t, 'homePageCompany:section4:items').map((item, index) => {
            if (!item) return null;
            const { title, description, ctaLabel, ctaPath } = item;
            return (
              <Box
                background="white"
                borderRadius="2"
                pt="12px"
                px="20px"
                pb="3"
                flex="1"
                key={index}
                display="flex"
                flexDirection="column"
                justifyContent="space-between">
                <Box>
                  <Text fontSize="30px" lineHeight="40px" mb="3" fontWeight="700">
                    {index + 1}
                  </Text>
                  <Box display="flex" justifyContent="center" alignItems="center" mb="3" height="126px">
                    <Img
                      alt={`${section4ImageNames[index]} illustration`}
                      src={assetize(`/homepage/${section4ImageNames[index]}.webp`)}
                      srcRetina={assetize(`/homepage/${section4ImageNames[index]}@2x.webp`)}
                      fallback={assetize(`/homepage/${section4ImageNames[index]}.png`)}
                      fallbackRetina={assetize(`/homepage/${section4ImageNames[index]}@2x.png`)}
                      lazyloading={true}
                    />
                  </Box>
                </Box>
                <Box>
                  <Text mb={'4px'} fontSize="14px" lineHeight="18px" fontWeight="700">
                    {title}
                  </Text>
                  <Text fontSize="14px" lineHeight="18px" height="72px">
                    {description}
                  </Text>
                  {ctaLabel && (
                    <Box textAlign="left" mt="2">
                      <StyledWhiteButton as={Link} to={ctaPath || ''}>
                        {ctaLabel}
                      </StyledWhiteButton>
                    </Box>
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      <Testimonials role="corporate" />

      <Box mt={{ _: 8, lg: 20 }} maxWidth="1240px" mx="auto" px={{ _: 1, sm: 2, md: 3, lg: 4 }}>
        <Text tag="h2" styleName="wH2b" mb="6">
          {t('homePageCompany:section5:title')}
        </Text>

        <Box display="flex" gap="16px" flexDirection={{ _: 'column', lg: 'row' }}>
          {translateArray(t, 'homePageCompany:section5:items').map((item, index) => {
            if (!item) return null;
            const { title, description, ctaLabel, ctaPath } = item;
            return (
              <Box
                display={index === 2 ? 'none' : 'flex'}
                flexDirection="column"
                justifyContent="center"
                background="white"
                borderRadius="2"
                flex="1"
                key={index}
                px="3"
                py="8"
                textAlign="center">
                <Text maxWidth="420px" mx="auto" fontSize="32px" lineHeight="38px" fontWeight="700" mb={4}>
                  {title}
                </Text>
                <Text maxWidth="420px" mx="auto" color="#424547" fontSize="16px" lineHeight="20px" fontWeight="500">
                  {description}
                </Text>
                {ctaLabel && (
                  <Button as={Link} to={ctaPath || ''} styleType="secondary">
                    {ctaLabel}
                  </Button>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>

      <Box maxWidth="1240px" mx="auto" px={{ _: 1, sm: 2, md: 3, lg: 4 }} mt="14">
        <Box textAlign="center" py="9" bg="white" borderRadius="2" position="relative" overflow="hidden">
          <Text tag="h2" styleName="wH2b" mb="3">
            {t('homePageCompany:footer:title')}
          </Text>
          <Text fontSize="18px" lineHeight="24px" fontWeight="400" mb="6" maxWidth="717px" mx="auto">
            {t('homePageCompany:footer:description')}
          </Text>
          <ButtonGradient as={Link} mt={2} to={`${register.to}?role=${COMPANY}`}>
            {t('homePageCompany:footer:ctaLabel')}
          </ButtonGradient>
          <Box
            position="absolute"
            bottom="-5px"
            left="0"
            overflow="hidden"
            display={{ _: 'none', md: 'block' }}
            width="250px">
            <Img
              src={'/assets/waves/waveCorner1.webp'}
              srcRetina={'/assets/waves/waveCorner1@2x.webp'}
              fallback={'/assets/waves/waveCorner1.png'}
              fallbackRetina={'/assets/waves/waveCorner1@2x.png'}
              alt="section wave decoration"
              lazyloading={false}
            />
          </Box>

          <Box
            position="absolute"
            bottom="-5px"
            right="0"
            overflow="hidden"
            display={{ _: 'none', md: 'block' }}
            width="350px">
            <Img
              src={'/assets/waves/waveCorner2.webp'}
              srcRetina={'/assets/waves/waveCorner2@2x.webp'}
              fallback={'/assets/waves/waveCorner2.png'}
              fallbackRetina={'/assets/waves/waveCorner2@2x.png'}
              alt="section wave decoration"
              lazyloading={false}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CompanyHomePage;
